namespace B2B.Landing {
    export class GymListSection {
        public static Instance: GymListSection;
        private _element: HTMLElement;

        constructor(element: HTMLElement) {
            if (GymListSection.Instance) {
                throw new Error("Use GymListSection.Instance");
            }

            GymListSection.Instance = this;

            this._element = element;

            // best
            let sliderElement = $('.js-gym-list-slider');
            sliderElement.owlCarousel({
                lazyLoad: true,
                items: 5,
                nav: true,
                dots: false,
                dotsEach: true,
                loop: true,
                smartSpeed: 550,
                autoplay: false,
                autoplayTimeout: 4000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 3,
                    },
                    992: {
                        items: 5,
                    },
                    1250: {
                        items: 5,
                    }
                }
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    let element = <HTMLElement>document.querySelector('#gym-list-section');
    if (element) {
        new B2B.Landing.GymListSection(element);
    }
});